var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDarkModeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#1F4782"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9799 14.3161C17.5547 15.2911 16.871 16.1407 15.9977 16.7793C15.1243 17.4179 14.0921 17.823 13.005 17.9538C11.9179 18.0846 10.8144 17.9364 9.80546 17.5243C8.79654 17.1121 7.91789 16.4505 7.258 15.606C6.59811 14.7616 6.18029 13.7641 6.0466 12.7141C5.91291 11.664 6.06809 10.5985 6.49649 9.62483C6.9249 8.65115 7.61141 7.80367 8.48689 7.16774C9.36237 6.53182 10.3959 6.12991 11.4834 6.00248C11.5589 5.99378 11.6352 6.00809 11.7018 6.0434C11.7684 6.07872 11.8219 6.13327 11.8548 6.19942C11.8893 6.26435 11.9014 6.33814 11.8897 6.41018C11.8779 6.48222 11.8427 6.5488 11.7893 6.60033C11.3429 7.02804 10.9898 7.53783 10.7508 8.09958C10.5119 8.66133 10.392 9.26364 10.3982 9.87091C10.4046 10.6691 10.625 11.4521 11.038 12.1436C11.4509 12.835 12.0422 13.4114 12.7544 13.8166C13.4666 14.2217 14.2752 14.4418 15.1017 14.4554C15.9281 14.469 16.7441 14.2756 17.4701 13.8941C17.5375 13.8605 17.6138 13.8472 17.6891 13.856C17.7645 13.8648 17.8353 13.8952 17.8925 13.9433C17.9413 13.9916 17.9752 14.052 17.9907 14.1178C18.0061 14.1836 18.0024 14.2522 17.9799 14.3161Z",
    fill: "#E1E1E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkModeDark);
export default __webpack_public_path__ + "static/media/icon-dark-mode-dark.7ec3b3bccbc72a2c3d0eccd932e82bc4.svg";
export { ForwardRef as ReactComponent };